/* eslint-disable prettier/prettier */

/**
The main entry point for the site.

Handles all Global JS for the site. E.g. search, newsletter signup, footer, etc.
* */
import { AdminNav } from "@outdoor-voices/ui";
import * as Sentry from "@sentry/browser";
import React from "react";
import ReactDOM from "react-dom";
import smoothscroll from "smoothscroll-polyfill";
import addClass from "./utils/dom/addClass"; // import addSmartBanner from './apps/index/smartBanner';

import checkForDoer from "./apps/index/doers";
import initAlert from "./apps/index/alert";
import initChat from "./apps/index/chat";
import initCustomer from "./apps/index/customer";
import removeClass from "./utils/dom/removeClass";
import "./scss/global.scss";
import "lazysizes";
import "lazysizes/plugins/attrchange/ls.attrchange";
import { jsx as _jsx } from "react/jsx-runtime";
window.React = React;
window.addEventListener("unhandledrejection", function (event) {
  console.warn("UNHANDLED PROMISE REJECTION: ".concat(event.reason));
});
var _document = document,
    body = _document.body;
var _window$OV = window.OV,
    CUSTOMER = _window$OV.CUSTOMER,
    NAV = _window$OV.NAV;
initCustomer();
initAlert(); // Add the admin nav if it's present

if (NAV !== null && NAV !== void 0 && NAV.admin) {
  var adminElement = document.createElement("div");
  document.body.append(adminElement);
  ReactDOM.render( /*#__PURE__*/_jsx(AdminNav, {
    links: NAV.admin
  }), adminElement);
}

Sentry.init({
  dsn: "https://b1f328fdd1e54d269a6e46ca4aa062fa@o57538.ingest.sentry.io/154719",
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0
});

if (CUSTOMER.loggedIn) {
  Sentry.configureScope(function (scope) {
    scope.setUser({
      email: CUSTOMER.email,
      id: CUSTOMER.id
    });
  });
} // touch detection


if ("ontouchstart" in window) {
  removeClass(body, "no-touch");
  addClass(body, "touch");
} // Initialize the chat


initChat(); // Polyfill the smoothscroll

smoothscroll.polyfill(); // Check if the user is a doer

checkForDoer(); // addSmartBanner();